<template>
    <div class="affiliation-error-page">
        <LockedYellowGreen class="affiliation-error-page__illustration" />
        <h1 class="typographies-display-medium affiliation-error-page__title">
            {{ $l10n.__('Accès en attente') }}
        </h1>
        <p
            class="typographies-paragraph-x-large-regular affiliation-error-page__text"
            v-html="affiliationText"
        />
    </div>
</template>

<script>
import LockedYellowGreen from 'vcomponents/icons/IconLockedYellowGreen.vue';
export default {
    components: {
        LockedYellowGreen,
    },
    computed: {
        affiliationText() {
            return this.$l10n.__(
                'Votre administrateur doit signer les Conditions Générales de Parrainage depuis son %(br)s module parrainage pour que vous puissiez accéder à cette ressource.',
                { br: '<br />' },
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.affiliation-error-page {
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: var(--spacing-7) 0 0;

    text-align: center;

    &__illustration {
        width: 170px;
        height: 170px;
    }

    &__title {
        margin: 0 0 var(--spacing-4);
        font-weight: var(--font-weights-proxima-nova-0);
    }

    &__text {
        margin: 0 0 var(--spacing-6);
        color: var(--colors-common-text-standard-caption);
    }
}
</style>
